<template>
	<div class="grid grid-cols-1 gap-4 md:grid-cols-3 md:flex-row">
		<div
			style="border-radius: 51% 49% 39% 61% / 49% 41% 59% 51%"
			class="flex aspect-square max-h-62.5 w-auto grow items-center justify-center p-1"
			:class="accentColorImage"
		>
			<img
				:src="sponsor.logoUrl"
				:alt="sponsor.name"
				class="h-full w-auto border object-cover"
				:class="borderColor"
				style="border-radius: 43% 57% 62% 38% / 32% 52% 48% 68%"
			/>
		</div>
		<div class="order-first md:order-last md:col-span-2">
			<h2 class="mt-1 mb-1 text-xl md:text-2xl" :class="accentColorText">
				{{ sponsor.name }}
			</h2>
			<p class="ml-1 text-pretty">
				{{ sponsor.description }}
			</p>
		</div>
	</div>
</template>

<script lang="ts" setup>
const props = defineProps<{
	sponsor: Sponsor
	index: number
}>()

const relativeIndex = props.index % 4

const accentColorImage = computed(() => {
	switch (relativeIndex) {
		case 0:
			return 'bg-darkestRed'
		case 1:
			return 'bg-brightRed'
		case 2:
			return 'bg-darkestGreen'
		case 3:
			return 'bg-brightGreen'
		default:
			return 'bg-darkestRed'
	}
})

const accentColorText = computed(() => {
	switch (relativeIndex) {
		case 0:
			return 'text-darkestRed'
		case 1:
			return 'text-brightRed'
		case 2:
			return 'text-darkestGreen'
		case 3:
			return 'text-brightGreen'
		default:
			return 'text-darkestRed'
	}
})

const borderColor = computed(() => {
	switch (relativeIndex) {
		case 0:
			return 'border-darkestRed'
		case 1:
			return 'border-brightRed'
		case 2:
			return 'border-darkestGreen'
		case 3:
			return 'border-brightGreen'
		default:
			return 'border-darkestRed'
	}
})
</script>

<style></style>
